(function () {

    function initReveal(scope = document) {

        const items = scope.querySelectorAll('.reveal');

        if (!items.length) {
            return;
        }

        if (
            window.matchMedia(
                '(prefers-reduced-motion: reduce)'
            ).matches
        ) {
            items.forEach((item) => {
                item.classList.add('is-visible');
            });

            return;
        }

        const observer = new IntersectionObserver(
            (entries, observerInstance) => {

                entries.forEach((entry) => {

                    if (!entry.isIntersecting) {
                        return;
                    }

                    entry.target.classList.add('is-visible');

                    observerInstance.unobserve(entry.target);
                });

            },
            {
                threshold: 0.12,
                rootMargin: '0px 0px -8% 0px'
            }
        );

        items.forEach((item) => {
            observer.observe(item);
        });

    }


    if (document.readyState === 'loading') {

        document.addEventListener(
            'DOMContentLoaded',
            function () {
                initReveal();
            }
        );

    } else {

        initReveal();

    }


    /*
     * ACF Gutenberg previews.
     */
    if (window.acf) {

        window.acf.addAction(
            'render_block_preview',
            function ($block) {

                $block.find('.reveal').each(function () {
                    this.classList.add('is-visible');
                });

            }
        );

    }

})();